function generateBarcodeWidthAndHeight() {
    var barcodeWidth = 303;
    var barcodeHeight = Math.floor(barcodeWidth * 0.4);
    if (window.devicePixelRatio > 1) {
        barcodeWidth = Math.floor(barcodeWidth * window.devicePixelRatio);
        barcodeHeight = Math.floor(barcodeHeight * window.devicePixelRatio);
    }
    return {
        barcodeWidth: barcodeWidth,
        barcodeHeight: barcodeHeight,
    };
}
/**
 * suc as https://sbg.jp/[nw7,code128]/240/72/0/1/A3871254736148C.jpg
 * https://sbg.jp/nw7/[WidthPixel]/[HeightPixel]/[RotateAngle]/[TextDisplayOption]/[BarcodeData].[ImageFormat]
 * TextDisplayOption 0:非表示, 1:スタートストップビットアリ表示, 2:スタートストップビットなし表示
 * ピクセル固定だと解像度が高いスマホで表示したときにバーコード画像が小さくなる可能性があるため、ロジックを流用する。
 * バーコード形式: nw7,code128
 */
export function barcodeImageSrcGenerator(input) {
    var _a = generateBarcodeWidthAndHeight(), barcodeWidth = _a.barcodeWidth, barcodeHeight = _a.barcodeHeight;
    return input.barcode.imageServer + "/" + input.barcode.barcodeType + "/" + barcodeWidth + "/" + barcodeHeight + "/0/1/" + input.barcode.barcodeValue + ".jpg";
}
/**
 * suc as https://sbg.jp/qr/10/12345.jpg
 * https://sbg.jp/be/qr.php?s=[サイズ]&d=[URLエンコード済み値]&f=jpg
 * ピクセル固定だと解像度が高いスマホで表示したときにバーコード画像が小さくなる可能性があるため、ロジックを流用する。
 * バーコード形式: qr
 */
export function qrBarcodeImageSrcGenerator(input) {
    // QRの場合は文字列(URLなど)もいけるため、URLエンコードする
    var encodeBarcodeValue = encodeURIComponent(input.barcode.barcodeValue);
    return input.barcode.imageServer + "/be/qr.php?s=" + input.size + "&d=" + encodeBarcodeValue + "&f=jpg";
}
/**
 * suc as https://sbg.jp/[jan13,jan8]/240/72/0/A3871254736148C.jpg
 * https://sbg.jp/jan13/[WidthPixel]/[HeightPixel]/[RotateAngle]/[BarcodeData].[ImageFormat]
 * バーコード形式: jan13,jan8
 */
export function janBarcodeImageSrcGenerator(input) {
    var _a = generateBarcodeWidthAndHeight(), barcodeWidth = _a.barcodeWidth, barcodeHeight = _a.barcodeHeight;
    return input.barcode.imageServer + "/" + input.barcode.barcodeType + "/" + barcodeWidth + "/" + barcodeHeight + "/0/" + input.barcode.barcodeValue + ".jpg";
}
//# sourceMappingURL=utils.js.map